import { faDollar } from '@fortawesome/free-solid-svg-icons';
import SpringbigPayScreen from './SpringbigPay';
import Transactions from './Card/Transactions/Transactions';
import TransactionDetails from './Card/Transactions/TransactionDetails';
const routes = {
    'w/:wallet_id/giftCard': {
        path: 'w/:wallet_id/giftCard',
        title: 'SpringbigPay',
        component: SpringbigPayScreen,
        mainPage: true,
        auth: true,
        exact: true,
        showTab: true,
        icon: faDollar
    },
    'w/:wallet_id/giftCard/:gift_card_id': {
        path: 'w/:wallet_id/giftCard/:gift_card_id',
        title: 'Transactions',
        component: Transactions,
        auth: true,
        exact: true,
        showTab: false
    },
    'w/:wallet_id/giftCard/transactions': {
        path: 'w/:wallet_id/giftCard/:gift_card_id/transaction/:transaction_id',
        title: 'Transactions',
        component: TransactionDetails,
        auth: true,
        exact: true,
        showTab: false
    },
};
export default routes;
